import { 
    REQUEST_EXAMS,
    RECEIVED_EXAMS,
    CLEAR_EXAMS,
    SEND_EXAM_PREFERENCES,
    SUCCESS_EXAM_PREFERENCES,
    ERROR_EXAM_PREFERENCES,
    ERROR_EXAMS
} from './../constants';

    export default function(state = {}, action) {
        switch(action.type){
            case REQUEST_EXAMS: 
                return {
                    ...state,
                    loading: true,
                    error: false,
                    errorInfo: null
                }
            case RECEIVED_EXAMS:
                return {
                    ...state,
                    loading: false,
                    error: false,
                    errorInfo: null,
                    exams: action.exams                    
                }
            case ERROR_EXAMS:
                return {
                    ...state,
                    loading: false,
                    exams: null,
                    error: true,
                    errorInfo: action.err                    
                    }    
                     
            case CLEAR_EXAMS:
                return {}
            default: return state
        }
    }